import apiHandler from "../core/apiHandler";

const inventoryDashboardApi = apiHandler('dashboard/inventory');
export default inventoryDashboardApi;
